module.exports = __webpack_public_path__ + "static/media/mobile_dicero_page_area02_img_en.716bf569.png";